<template>
	<div>
	    <van-nav-bar title="商机详情" left-text="返回" left-arrow @click-left="onClickLeft" fixed>
		<div slot="right">
			<span style="color:#1890ff;" @click="tranferProject()">转化</span>
			<span style="color:#1890ff;margin-left:20px;" @click="showPopup">详细</span>
		</div>
		</van-nav-bar>
		<div class="cardTop">
			 <table class="layout">
			    <tr>
			        <td class="avatar-box" rowspan="4">
			            <img :src="avatarUrl + saleChance.advisorIdavatar" class="avatar" alt="avatar">
			            <p class="advisor">{{saleChance.advisorIdname}}</p>
			        </td>
			        <td colspan="2">
			            <div class="header">
			                <span class="title">{{saleChance.name || "无"}}</span>
			            </div>
			        </td>
			    </tr>
			    <tr>
			        <td colspan="2" class="content">
			            <p v-for="field in displayField" :key="field.fieldName">
			                <span :class="icon + field.appIcon"></span>
			                <span>{{saleChance[field.dictionary ? field.fieldName+'name':field.fieldName] || '无'}}</span>
			            </p>
			        </td>
			    </tr>
			</table>
		</div>
		<tabs :id="chanceId" host="chance" :advisorId="advisorId"></tabs>
		<van-popup v-model="showTableGrid" position="right">
            <van-nav-bar title="详情" left-text="返回" left-arrow @click-left="cancel"></van-nav-bar>
             <table-grid table-name="crm_sale_chance" :data-id="chanceId" :grouping="grouping" @savecomplate="cancel">
            </table-grid>
        </van-popup>
	</div>
</template>

<script>
	import {NavBar,Button,Toast,Icon,Dialog,Popup} from 'vant';
	import moment from "moment";
	import userInfo from '../store/userInfo';
	import saleChanceService from "../service/saleChanceService";
	import tabs from "../components/Tabs";
	import {API_URL} from "../common/config";
	import fieldDescriptionService from "../service/fieldDescriptionService";
	import {formatDictionary} from "../utils/dictionary";
	export default {
		data() {
			return {
				chanceId: '',
				showTableGrid: false,
				grouping: false,
				advisorId:'',
				saleChance: {},
				displayField:[],
				dictionary: {}
			};
		},
		store: userInfo,
		components: {
			tabs,
		    [NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog,
			[Popup.name]: Popup
		},
		computed: {
			userId() {
			    return this.$store.getters.getUserId;
			},
		    avatarUrl() {
		        return API_URL + "/oa/common/attachment/showImage?id=";
		    },
			icon() {
			    return "iconfont ";
			}
		},
		created: async function() {
			
		   this.chanceId = this.$route.query.uuid;
			this.advisorId = this.$route.query.advisorId;
			//this.saleChance = JSON.parse(this.$route.query.saleChance);
			this.dictionary = JSON.parse(this.$route.query.dictionary);
			this.load();
			if (this.displayField.length < 1){
			    let displayField = await fieldDescriptionService.getFieldDisplayOnAPP("crm_sale_chance");
			    if (displayField.data.Status === "1") {
			        this.displayField = displayField.data.Data;
							
			    }
			}
			
		},
		methods:{
			async load() {
				let resp = await saleChanceService.getChanceById(this.chanceId);
				if (resp.data.Status === "1") {
					formatDictionary([resp.data.Data], this.dictionary);
					this.saleChance = resp.data.Data;
				}
			},
			async tranferProject() {
				if(this.advisorId !== this.userId) {
					Toast.fail('你无权把他人的商机转化为项目！');
					return;
				}
				let result = await saleChanceService.getTransformProject(this.saleChance.code);
				if (result.data.Status === "1") {
				    var workflowTemplateId="f3f6afbe8fae4ab0bddc483cf9531e28";
                    if(result.data.Data.code&&result.data.Data.code===this.saleChance.code) {
						let defaultValue = {
							formName: '项目报备申请'
						}
						this.$router.push("/app/form/" + workflowTemplateId + "/" + result.data.Data.uuid + "/" + JSON.stringify(defaultValue));
                    }else {
						let arg = {
							chanceId: this.saleChance.uuid,
							code: this.saleChance.code,
							advisorId: this.saleChance.advisorId,
							region: this.saleChance.region,
							regionProvince: this.saleChance.province,
							source: this.saleChance.source,
							projectName: this.saleChance.name,
							formName: '项目报备申请'
						}
                        this.$router.push("/app/form/" + workflowTemplateId + "/" + 0 + "/" + JSON.stringify(arg));
                    }
				}
			},
		    onClickLeft() {
		        this.$router.go(-1);
		    },
			cancel() {
				this.showTableGrid = false;
				this.load();
			},
			showPopup() {
				this.showTableGrid = true;
			}
		}
	}
</script>

<style>
	.cardTop{
		margin-top:120px;
		padding: 1rem;
		font-size:0.8rem;
	}
	.van-popup--right {
	    width: 100%;
	    height: 100%;
	}
</style>
